import { createBrowserHistory } from "history";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Fulltest from "./components/FullTestPage";
import Shorttest from "./components/ShortPage";
import SpeakingAiPage from "./components/SpeakingAIPage";

import CreateAccount from "./components/Auth/CreateAccountPage";
import ForgotPassword from "./components/Auth/ForgotPasswordPage";
import Login from "./components/Auth/LoginPage";
import Completing from "./components/Completing";
import ExamByCode from "./components/ExamByCodePage";
import ExamBySlug from "./components/ExamBySlugPage";
import HomePage from "./components/HomePage";
import ListTest from "./components/ListTestPage";
import NewWelcome from "./components/NewWelcome";
import NotFound from "./components/NotFoundPage";
import ResultAnalysis from "./components/ResultAnalysis";
import ResultAnalysisAi from "./components/ResultAnalysisAi";
import AuthRoute from "./components/Route/AuthRoute";
import RealIELTSRoute from "./components/Route/RealIELTSRoute";
import UserRoute from "./components/Route/UserRoute";
import Survey from "./components/SurveyPage";
import AssesmentHistory from "./components/UserPage/AssesmentHistory";
import AssesmentById from "./components/UserPage/AssesmentHistory/AssesmenById";
import AssesmentByIdNew from "./components/UserPage/AssesmentHistory/AssesmenByIdNew";
import OverView from "./components/UserPage/AssesmentHistory/OverView";
import MyAccount from "./components/UserPage/MyAccount";
import MyCourse from "./components/UserPage/MyCourse";
import Welldone from "./components/Welldone/Welldone";

function App() {
  const history = createBrowserHistory();

  return (
    <>
      <Routes history={history}>
        <Route path="/" element={<HomePage />} />
        <Route path="/exam-by-code" element={<ExamByCode />} />
        <Route path="/exam-by-slug" element={<ExamBySlug />} />
        <Route path="/list-test" element={<ListTest />} />
        <Route element={<AuthRoute />}>
          <Route path="/welcome" element={<NewWelcome />} />
          <Route path="/welldone" element={<Welldone />} />
          <Route path="/result-analysis" element={<ResultAnalysis />} />
          <Route path="/result-analysis-ai" element={<ResultAnalysisAi />} />
          <Route path="/completing" element={<Completing />} />
          <Route path="/survey" element={<Survey />} />
        </Route>
        <Route element={<RealIELTSRoute />}>
          <Route path="/shorttest" element={<Shorttest />} />
          <Route path="/fulltest" element={<Fulltest />} />
        </Route>
        <Route path="/speakingai" element={<SpeakingAiPage />} />
        {/*

        {/* <Route element={<GuestIELTSRoute />}>
          <Route path="/listening" element={<NewListening />} />
          <Route path="/reading" element={<ReadingPage />} />
          <Route path="/writing" element={<WritingPage />} />
        </Route> */}
        {/* <Route path="/speaking" element={<SpeakingPage />} /> */}
        <Route path="/auth">
          <Route path="login" element={<Login />} />
          <Route path="register" element={<CreateAccount />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="*" element={<NotFound />}></Route>
        </Route>
        <Route path="/user" element={<UserRoute />}>
          <Route index path="profile" element={<MyCourse />} />
          <Route path="assesment-history" element={<AssesmentHistory />} />
          <Route path="assesment/:id" element={<AssesmentById />} />
          <Route path="assesment/overview/:id" element={<OverView />} />
          <Route path="account" element={<MyAccount />} />
          <Route path="*" element={<NotFound />}></Route>
        </Route>
        <Route path="assesment-detail/:id" element={<AssesmentByIdNew />} />
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
      <ToastContainer />
    </>
  );
}

export default App;
